import { appNavigation } from "../../styles/appNavigation";
import IconHelper from "./IconHelper";

const DashboardIcon = (props) => (
  <IconHelper {...props} defaultWidth={24} defaultHeight={24}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_5960_1261" fill="white">
        <path d="M5.7679 1.63633C4.62711 1.63633 3.51195 1.97461 2.56342 2.60839C1.6149 3.24218 0.875613 4.143 0.439055 5.19694C0.00249624 6.25089 -0.111727 7.41062 0.110828 8.52948C0.333384 9.64835 0.882723 10.6761 1.68938 11.4827C2.49603 12.2894 3.52377 12.8387 4.64264 13.0613C5.7615 13.2838 6.92123 13.1696 7.97517 12.7331C9.02912 12.2965 9.92994 11.5572 10.5637 10.6087C11.1975 9.66017 11.5358 8.545 11.5358 7.40422L5.7679 7.40422L5.7679 1.63633Z" />
      </mask>
      <path
        d="M5.7679 1.63633C4.62711 1.63633 3.51195 1.97461 2.56342 2.60839C1.6149 3.24218 0.875613 4.143 0.439055 5.19694C0.00249624 6.25089 -0.111727 7.41062 0.110828 8.52948C0.333384 9.64835 0.882723 10.6761 1.68938 11.4827C2.49603 12.2894 3.52377 12.8387 4.64264 13.0613C5.7615 13.2838 6.92123 13.1696 7.97517 12.7331C9.02912 12.2965 9.92994 11.5572 10.5637 10.6087C11.1975 9.66017 11.5358 8.545 11.5358 7.40422L5.7679 7.40422L5.7679 1.63633Z"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1.6"
        mask="url(#path-1-inside-1_5960_1261)"
      />
      <mask id="path-2-inside-2_5960_1261" fill="white">
        <path d="M13.0085 6.21787C13.0085 5.40133 12.8477 4.59278 12.5352 3.8384C12.2227 3.08401 11.7647 2.39856 11.1873 1.82117C10.6099 1.24379 9.92449 0.785785 9.1701 0.473307C8.41572 0.16083 7.60717 -3.56922e-08 6.79063 0L6.79063 6.21787L13.0085 6.21787Z" />
      </mask>
      <path
        d="M13.0085 6.21787C13.0085 5.40133 12.8477 4.59278 12.5352 3.8384C12.2227 3.08401 11.7647 2.39856 11.1873 1.82117C10.6099 1.24379 9.92449 0.785785 9.1701 0.473307C8.41572 0.16083 7.60717 -3.56922e-08 6.79063 0L6.79063 6.21787L13.0085 6.21787Z"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1.6"
        mask="url(#path-2-inside-2_5960_1261)"
      />
    </svg>
  </IconHelper>
);

export default DashboardIcon;
